import * as React from "react";

export default function SelectionsCounter() {

  return (<div/>
  );
}



// WEBPACK FOOTER //
// ./src/components/SelectionsCounter/SelectionsCounter.tsx